/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState } from 'react'
import { useAppSelector, useAppDispatch } from "../../../../../../../redux/hook";
import { addTemplateNewPosition, duplicateTemplatePosition, removeTemplatePosition, setPrevTemplate, setTemplate, updateTemplatePosition } from '../../../../../../../redux/slices/template/templateSlice';
import { ASPECT_RATIOS, defaultPositionLandscape, Position, Template } from '../../../../../../../redux/slices/template/templateModels';
import { setTemplateSettings } from '../../../../../../../redux/slices/editor/editorSlice';
import Swal from 'sweetalert2';
import { KTSVG } from '../../../../../../../../_metronic/helpers';
import { defaultThumbnails } from '../../../../../../../redux/slices/media/mediaModels';

//----------------------------------------

type Props = {
  className: string,
}




//----------------------------------------
export const TemplateEditorTools: React.FC<Props> = ({className}) => {
  
  const dispatch = useAppDispatch()  
  //-----------------------------------------
  // const currContentPersistor = useAppSelector(state => state.persistor._content.currContent)
  // console.log("currContentPersistor", currContentPersistor)
  const currPersistTemplate = useAppSelector(state => state.persistor._template.currTemplate)
  // console.log("currPersistTemplate", currPersistTemplate)

  const isTempltEditorFlag = useAppSelector(state => state.persistor._template.isTemplateEditor)
  // console.log("isTempltEditorFlag: ", isTempltEditorFlag)

  // const newTmpltSetting = useAppSelector(state => state.persistor._template.templateSettings)
  // console.log("newTmpltSetting: ", newTmpltSetting)

  const newTmpltSetting = useAppSelector(state => state.editor.templateToolsSettings)
  // console.log("newTmpltSetting in EditorTools: ", newTmpltSetting)
  
  //-----------------------------------------
  const handleAddNewPosition = ({type = "video", ratio="16:9"}) => {
    const newLastIndex = currPersistTemplate && currPersistTemplate.positions ? (currPersistTemplate.positions[currPersistTemplate.positions.length -1].layer +1) : 1
    
    let dims = {w: 960, h: 540} //"16:9"
    switch (newTmpltSetting.ratio){
      case "16:9"   :  dims = {w: 16 *1   *60, h:  9 *1   *60};  break;
      case "5:4"    :  dims = {w:  5 *2.25*60, h:  4 *2.25*60};  break;
      case "4:3"    :  dims = {w:  4 *3   *60, h:  3 *3   *60};  break;
      case "2:1"    :  dims = {w:  2 *9   *60, h:  1 *9   *60};  break;

      case "9:16"   :  dims = {w:  9 *1   *60, h: 16 *1   *60};  break;
      case "4:5"    :  dims = {w:  4 *2.25*60, h:  5 *2.25*60};  break;
      case "3:4"    :  dims = {w:  3 *3   *60, h:  4 *3   *60};  break;
      case "1:2"    :  dims = {w:  1 *9   *60, h:  2 *9   *60};  break;

      case "Square" :  dims = {w:  9 *1   *60, h:  9 *1   *60};  break;
      case "Full L" :  dims = {w: 16 *2   *60, h:  9 *2   *60};  break;      
      case "Full P" :  dims = {w:  9 *2   *60, h: 16 *2   *60};  break;      
    }

    dispatch(addTemplateNewPosition(
      { ...defaultPositionLandscape, 
        x: 0,
        y: 0,
        ...dims,
        layer: newLastIndex,
        element_type: type,
        // alias: `custom_${newLastIndex}`,
        // alias: Math.random().toString(9).slice(0,5).replace('0.', '').toUpperCase(),
        alias: (currPersistTemplate.positions? currPersistTemplate.positions.length +1 : 1)+""
      }
    ))  

    dispatch(setTemplateSettings({...newTmpltSetting, type: type}))
  }

  // --------------------------------------
  const handleDuplicatePosition = (selectedId="") => {
    
    if (selectedId){      
      dispatch(duplicateTemplatePosition(selectedId))        
    }
  }

  // --------------------------------------
  const handleDeletePosition = (selectedId="") => {

    if (selectedId){
      Swal.fire({
        title: 'Are you sure you want to remove this section?<h1 style="color:#331168; margin: 15px 0;">'+ selectedId +'</h1>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#9C258F',
        cancelButtonColor: '#E4E6EF',
        confirmButtonText: 'Continue',
        customClass: {          
          cancelButton: 'order-1 left-gap me-5',
          confirmButton: 'order-2',
        }
      }).then(async (result) => {
        if (result.isConfirmed) {
          dispatch(removeTemplatePosition(selectedId))
          dispatch(setTemplateSettings({...newTmpltSetting, selectedSect: ""})) 
        }
      })
    }
  }

  // --------------------------------------
  const handleChangeTypePosition = (newType="video", selectedId="") => {

    if (selectedId){
      console.log("currPersistTemplate", currPersistTemplate)
      console.log("selectedId", selectedId)
      
      const foundPosition = currPersistTemplate.positions?.filter(pos => pos.alias === selectedId);
      if (foundPosition && currPersistTemplate.positions){
        dispatch(setPrevTemplate(currPersistTemplate));

        const newTmplt: Template =  { ...currPersistTemplate,
                                      positions : currPersistTemplate.positions.map((pos) => { 
                                                                                              if (pos.alias !== selectedId){
                                                                                                return pos;
                                                                                              }else{
                                                                                                return {...pos, element_type: newType};
                                                                                              }
                                                                                            })
                                    }
        dispatch(setTemplate(newTmplt));  
      }           
    }

    dispatch(setTemplateSettings({...newTmpltSetting, type: newType}))
  }

  //-----------------------------------------
  return (
    <>      
      <div 
        className='h-100 w-100 mx-0'
        style={{
          maxHeight:"100%",
          overflowX:"hidden"
          // scrollbarWidth: "thin"
        }}
      >
        <div 
          id="kt_accordion_2" 
          className="accordion accordion-icon-toggle galleryFilePanel" 
          style={{maxHeight:"100%", overflowX:"hidden"}}
        >          
          <div className="px-4 pb-4 sticky-top bg-gray-300">
            <div className='d-flex flex-column mt-6'>
              {/* <div className='group-1 mb-4'>
                <div><i className='fa fa-caret-right me-2'></i>Add New Section</div>
                <div className='mt-2 ms-4'>
                  <div className='btn-group shadow-sm me-3' role='group'>
                    <button className={`btn btn-icon ${ newTmpltSetting.type==="video"?"btn-dark"
                                                      : newTmpltSetting.type==="web"?"btn-light-primary border border-1 border-primary"
                                                      : newTmpltSetting.type==="text"?"btn-light-info border border-1 border-info"
                                                      : newTmpltSetting.type==="widget"?"btn-light-success border border-1 border-success"
                                                      : "btn-light"} 
                      tooltip-bottom`}
                      data-tooltip-content='New section'
                      // disabled = {newTmpltSetting.selectedSect}                      
                      onClick={()=> { handleAddNewPosition({type: newTmpltSetting.type}); }}
                    >
                      <i className='fa fa-plus'></i>                     
                    </button>                        
                  </div>
                </div>
              </div> */}
              {/* <div className='group-1 mb-4'>
                <div><i className='fa fa-caret-right me-2'></i>Edit</div>
                <div className='mt-2 ms-4'>                  
                  <div className='btn-group shadow-sm' role='group'>
                    <button className='btn btn-icon btn-light tooltip-bottom'
                      data-tooltip-content='Duplicate section'
                      disabled = {! newTmpltSetting.selectedSect}
                      onClick={()=> { handleDuplicatePosition(newTmpltSetting.selectedSect)  }}
                    >
                      <i className='fa fa-clone'></i>
                    </button>
                    <button className='btn btn-icon btn-light tooltip-bottom'
                      data-tooltip-content='Delete section'
                      disabled = {! newTmpltSetting.selectedSect}
                      onClick={()=> { handleDeletePosition(newTmpltSetting.selectedSect)  }}
                    >
                      <i className='fa fa-trash'></i>
                    </button>                    
                  </div>
                </div>
              </div> */}
              <div className='group-2 mb-4'>
                <div><i className='fa fa-caret-right me-2'></i>Add New Section</div>
                <div className='mt-2 ms-4'>
                  <button className={`btn btn-icon ${newTmpltSetting.type === "video" ? "bg-gray-400 border-gray-500":"btn-secondary border-gray-500"} border border-1 shadow-sm tooltip-bottom`}
                    data-tooltip-content='Add image/video'                    
                    onClick={()=> { 
                      // handleChangeTypePosition("video", newTmpltSetting.selectedSect) 
                      handleAddNewPosition({type: "video"});
                    }}                      
                  >
                    <img src={`${defaultThumbnails[0]}`} className='w-50'/>
                  </button>
                  <button className={`btn btn-icon ${newTmpltSetting.type === "web" ? "btn-light-primary border-primary":"btn-secondary border-gray-500"} border border-1 shadow-sm tooltip-bottom ms-3`}
                    data-tooltip-content='Add Web'
                    onClick={()=> { 
                      // handleChangeTypePosition("web", newTmpltSetting.selectedSect) 
                      handleAddNewPosition({type: "web"});
                    }}                      
                  >
                    <i className='fa fa-globe fs-4'></i>
                  </button>
                  <button className={`btn btn-icon ${newTmpltSetting.type === "text" ? "btn-light-info border-info":"btn-secondary border-gray-500"} border border-1 shadow-sm tooltip-bottom ms-3`}
                    data-tooltip-content='Add text'
                    onClick={()=> { 
                      // handleChangeTypePosition("text", newTmpltSetting.selectedSect) 
                      handleAddNewPosition({type: "text"});
                    }}                      
                  >
                    <KTSVG path={`/media/icons/duotune/art/art001.svg`} className={`m-0 svg-icon-2`}/>
                  </button>
                  <button className={`btn btn-icon ${newTmpltSetting.type === "widget" ? "btn-light-success border-success":"btn-secondary border-gray-500"} border border-1 shadow-sm tooltip-bottom ms-3`}
                    data-tooltip-content='Add widget'
                    onClick={()=> { 
                      // handleChangeTypePosition("widget", newTmpltSetting.selectedSect) 
                      handleAddNewPosition({type: "widget"});
                    }}                      
                  >                    
                    <KTSVG path={`/media/icons/duotune/general/gen025.svg`} className={`m-0 svg-icon-2`}/>
                  </button>
                </div>
              </div>
              {/* <div className='group-3 bg-gray-600 text-white rounded-top mt-8 mb-4 p-3'>
                <div className="text-gray-500">Settings</div>
              </div> */}
              <div className='group-4 mt-8 mb-4'>
                <div className=""><i className='fa fa-gears me-2'></i>Aspect Ratio </div>
                <div className='mt-2 ms-4'>
                  {ASPECT_RATIOS.map((aspRatioArr, ind) => {
                    if ((aspRatioArr.length >= 3) && (
                      (["landscape"].includes(newTmpltSetting.orientation) && ["Full L"].includes(""+aspRatioArr[0])) || 
                      (["portrait"].includes(newTmpltSetting.orientation) && ["Full P"].includes(""+aspRatioArr[0])) || 
                      (!["Full L", "Full P"].includes(""+aspRatioArr[0]))
                    )){
                      return <button className={`h-75px btn btn-icon ${newTmpltSetting?.ratio === aspRatioArr[0]? "text-primary fw-bold":"text-gray-500"} btn-sm px-8 me-3 tooltip-bottom`}
                                data-tooltip-content={`${aspRatioArr[0]}`}
                                onClick={()=> { dispatch(setTemplateSettings({...newTmpltSetting, ratio: `${aspRatioArr[0]}`})) }}
                              >
                                <div className='d-flex flex-column'>
                                  <div className={`border border-3 ${newTmpltSetting?.ratio === aspRatioArr[0]? "border-primary":"border-gray-500"} mb-2`}
                                  style={{width:`${parseInt(""+aspRatioArr[1]) * parseInt(""+aspRatioArr[3])}px`, height:`${(parseInt(""+aspRatioArr[2]) * parseInt(""+aspRatioArr[3]))}px`}}
                                  >&nbsp;</div>
                                  <div>{["Full L","Full P"].includes(""+aspRatioArr[0]) ? "Full" : aspRatioArr[0]}</div>
                                </div>
                              </button>
                    }else{
                      return <></>
                    }
                  })}
                </div>
              </div>
              
              {/* <button className='btn btn-primary h-100px mb-8'
                onClick={() => {}}
              >
                <i className='fa fa-video me-1'></i>Add Video Section
              </button>
              <button className='btn btn-primary h-100px mb-8'
                onClick={() => {}}
              >
                <i className='fa fa-font me-1'></i>Add Text Section
              </button>
              <button className='btn btn-primary h-100px mb-8'
                onClick={() => {}}
              >
                <i className='fa fa-globe me-1'></i>Add Web Section
              </button>
              <button className='btn btn-primary h-100px mb-8'
                onClick={() => {}}
              >
                <i className='fa fa-magic me-1'></i>Add Gadget Section (e.g., weather, timer, ....)
              </button>
              <div>
              + Other Editor tools 
              </div> */}
            </div>
          </div>
        </div>        
      </div>
    </>
  )
}

